import { IconProps } from './Icon';

export const PendingSupplierConfirmIcon = ({
  width,
  height,
  className,
}: IconProps) => (
  <svg
    className={className}
    height={height}
    viewBox="0 0 48 48"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(1.1699999999999997,0,0,1.1699999999999997,-4.079999999999995,-4.079995501041406)">
      <path
        d="M13.79 9H13c-1.06 0-2.08.42-2.83 1.17S9 11.94 9 13v27c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4V13c0-1.06-.42-2.08-1.17-2.83S36.06 9 35 9h-.79c-.34-1.18-1.42-2-2.66-2h-2.59c-.11-.74-.45-1.44-.99-1.98A3.455 3.455 0 0 0 25.5 4h-3.01c-.93 0-1.82.37-2.47 1.02-.54.54-.88 1.23-.99 1.98h-2.59c-1.24 0-2.32.82-2.66 2zm20.81 2c.06.71-.16 1.43-.62 1.99-.53.64-1.31 1.01-2.14 1.01h-15.7c-.83 0-1.61-.37-2.14-1.01-.46-.56-.68-1.27-.62-1.99h-.4c-.53 0-1.04.21-1.41.59-.38.37-.59.88-.59 1.41v27c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V13c0-.53-.21-1.04-.59-1.41-.37-.38-.88-.59-1.41-.59h-.4zM20 39h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1zm7-21h-8c-1.66 0-3 1.34-3 3v10c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-7c0-.55-.45-1-1-1s-1 .45-1 1v7c0 .55-.45 1-1 1H19c-.55 0-1-.45-1-1V21c0-.55.45-1 1-1h8c.55 0 1-.45 1-1s-.45-1-1-1zm-6.8 5.6 3 4c.18.24.46.39.76.4s.59-.11.79-.33l9-10a.989.989 0 0 0-.08-1.41.989.989 0 0 0-1.41.08l-8.19 9.1-2.27-3.03c-.33-.44-.96-.53-1.4-.2s-.53.96-.2 1.4zM21 7.49a1.499 1.499 0 0 1 1.5-1.5h3.01a1.499 1.499 0 0 1 1.5 1.5v.5c0 .94 1 1.01 1 1.01h3.55c.36 0 .68.26.75.61l.29 1.47c.04.22-.01.46-.16.63-.14.18-.36.28-.59.28h-15.7c-.23 0-.45-.1-.59-.28a.762.762 0 0 1-.16-.63l.29-1.47a.76.76 0 0 1 .75-.61h3.55s1-.07 1-1.01v-.5z"
        data-original="#000000"
        fill="#000000"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
